const campaignNotificationSelector = state => state?.campaignNotification?.campaign_notification;
export default campaignNotificationSelector;
